import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GetStatusIntegracaoUauController } from "../../../../Controllers/Geral/Dashboard/DashboardController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import OrSpinner from "../../../../Components/Utils/OrSpinner";

export default function StatusUAU() {
    const {
        value: getStatusIntegracaoUau,
        loading: getStatusIntegracaoUauLoading,
    } = useAsyncEffect(() => GetStatusIntegracaoUauController());

    const getStatus = (status: boolean) => {
        return status ? "success" : "danger";
    };

    return (
        <div className="card card-custom">
            <div className="card-header align-items-center justify-content-center">
                <div className="text-center flex-grow-1">
                    <div className="text-dark-75 font-weight-bold font-size-h5">
                        Status Integração UAU
                    </div>
                </div>
            </div>
            <OrSpinner loading={getStatusIntegracaoUauLoading} spinner="capys">
                <div className="card-body d-flex justify-content-between align-items-center">
                    <span className="flex-grow-1">
                        Serviço Integração CAPYS X UAU
                    </span>
                    <FontAwesomeIcon
                        icon={faCircle}
                        size="lg"
                        className={`text-${getStatus(
                            getStatusIntegracaoUau?.FL_STATUS_WEBSERVICE ??
                                false
                        )}`}
                    />
                </div>
                <div className="card-body d-flex justify-content-between align-items-center">
                    <span className="flex-grow-1">Serviço UAU API</span>
                    <FontAwesomeIcon
                        icon={faCircle}
                        size="lg"
                        className={`text-${getStatus(
                            getStatusIntegracaoUau?.FL_STATUS_API ?? false
                        )}`}
                    />
                </div>
                <div className="card-body d-flex justify-content-between align-items-center">
                    <span className="flex-grow-1">
                        Carga de Dados - Última carga -
                        {moment(
                            getStatusIntegracaoUau?.DT_ULTIMA_CARGA_DADOS
                        ).format("ll")}
                    </span>
                    <FontAwesomeIcon
                        icon={faCircle}
                        size="lg"
                        className={`text-${getStatus(
                            getStatusIntegracaoUau?.FL_STATUS_ETL ?? false
                        )}`}
                    />
                </div>
            </OrSpinner>
        </div>
    );
}
